import React, { Component } from 'react';
import Sound from 'react-sound';

export default class Player extends Component{
    state={

    };
    constructor(props) {
        super(props);
        const {handleFinish }=props;
        this.handleFinish=handleFinish;
    }

    render() {
        return (
            <Sound
                url="../sounds/facts/fact_speech_249.wav"
                playStatus={this.props.isPlaying?Sound.status.PLAYING :Sound.status.PAUSED}
                // onLoading={this.handleSongLoading}
                // onPlaying={this.handleSongPlaying}
                 onFinishedPlaying={this.handleFinish}
            />
        );
    }
}